import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./component/Header/Header";
import FooterSection from "./component/Footer/Footer";
import AllPackeges from "./pages/Packeges/AllPackeges";
import Home from "./pages/Home/Home";
import PackegDetails from "./pages/PackegDetails/PackegDetails";
import GalleryPage from "./pages/Gallery/GalleryPage";
import BlogLandingPage from "./pages/Blog/BlogLandingPage";
import BlogDetailsPage from "./pages/Blog/BlogDetailsPage";
import ContactUsPage from "./pages/Blog/ContactUsPage";
import AboutUs from "./pages/AboutUs/AboutUs";
import BASE_URL from "./component/commanfile";
import axios from "axios";
import { Button, Form, Modal } from "react-bootstrap";
import { Carousel } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";

function ScrollToTopOnRouteChange() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppContent() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [webSettings, setWebSettings] = useState(null);
  const [webTours, setWebTours] = useState([]);
  const location = useLocation();
const [adsData, setAdsData] = useState([]);
const [showAdsModal, setShowAdsModal] = useState(false);
const today = new Date().toISOString().split("T")[0];
  const [formData, setFormData] = useState({
    name: "",
    mobile_number: "",
    customerNotes: "",
    email: "",
    adults: "",         // New Field
    children: "",       // New Field
    tentativeDate: "",  // New Field
    type: "custom"
  });
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const res = await axios.post(
        `${BASE_URL}api/tourinquery`,
        {
          name: formData.name,
          mobileNumber: formData.mobile_number,
          customerNotes: formData.customerNotes,
          email: formData.email,
          adults: formData.adults,           // Added to payload
          children: formData.children,       // Added to payload
          tentativeDate: formData.tentativeDate, // Added to payload
          type: "custom"
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );


        setSuccess("Inquiry sent successfully! Our team will contact you soon.");
        // setFormData({ name: "", mobile_number: "", customerNotes: "", email: "", adults: "", children: "", tentativeDate: "", type: "custom" });

      // setTimeout(() => {
      //   setShowModal(false);
      //     setFormData({ name: "", mobile_number: "", customerNotes: "", email: "",  adults: "", children: "", tentativeDate: "",type: "custom" });
      //     setSuccess("");
      // }, 3000);
      
    } catch (err) {
      console.error("Tour inquiry error", err);
      setError("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const hideQuickInquiry =
    location.pathname.startsWith("/tour-details/");

  const [menus, setMenus] = useState([]);
  const [tourSector, setTourSector] = useState([]);

  console.log("menus", menus, tourSector, webSettings);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 200);
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const fetchHeaderData = async () => {
      try {
        const [menuRes, tourRes, settingsRes] = await Promise.all([
          axios.get(`${BASE_URL}api/web-menu`),
          axios.get(`${BASE_URL}api/web-tours`),
          axios.get(`${BASE_URL}api/web-settings`)
        ]);

        setMenus(menuRes.data || []);
        setWebTours(tourRes?.data?.sectors  || []);
        const data = tourRes?.data?.sectors || [];
        const grouped = data.reduce((acc, tour) => {
          let typeObj = acc.find(i => i.type === tour.tour_type_name);
          if (!typeObj) {
            typeObj = { type: tour.tour_type_name, sector: [] };
            acc.push(typeObj);
          }

          let sectorObj = typeObj.sector.find(
            s => s.sectorName === tour.sector_name
          );

          if (!sectorObj) {
            sectorObj = {
              sectorName: tour.sector_name,
              sectorId: tour.sector_id,
              tours: []
            };
            typeObj.sector.push(sectorObj);
          }

          sectorObj.tours.push(tour);
          return acc;
        }, []);

        setTourSector(grouped);
        setWebSettings(settingsRes.data);
      } catch (err) {
        console.error("Header data error", err);
      }
    };

    fetchHeaderData();
  }, []);

  useEffect(() => {
    function handleScroll() {
      setIsScrolled(window.scrollY > 200);
    }

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const headerStyle = {
    position: "sticky",
    top: 0,
    zIndex: 9999,
    width: "100%",
    transition: "background-color 0.3s ease, box-shadow 0.3s ease",
  };


  const mainContentStyle = {
    paddingTop: "0px",
  };
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [packages, setPackages] = useState([]); 
        const [hotPackages, setHotPackages] = useState([]); 

  const [homeImages, setHomeImages] = useState([]); 
  const [showModal, setShowModal] = useState(false);
  const theme = {
    primary: "#8f0909",
    dark: "#082e5e",
    light: "#f8f9fa"
  };

  const styles = {
    hero: {
      background: `linear-gradient(rgba(58, 57, 121, 0.8), rgba(10, 29, 55, 0.9)), 
                   url('https://images.unsplash.com/photo-1423666639041-f56000c27a9a?auto=format&fit=crop&w=1600&q=80')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      padding: "100px 0 140px", 
      textAlign: "center",
      position: "relative",
      width: "100%"
    },

    infoCard: {
      border: "none",
      borderRadius: "24px",
      padding: "30px",
      height: "100%",
      backgroundColor: "#fff",
      boxShadow: "0 15px 35px rgba(0,0,0,0.08)", 
      transition: "transform 0.3s ease",
      position: "relative",
      zIndex: 5 
    },
    iconBox: {
      width: "55px",
      height: "55px",
      borderRadius: "15px",
      backgroundColor: "#fff1f1",
      color: theme.primary,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "1.4rem",
      marginBottom: "20px"
    },
    input: {
      borderRadius: "12px",
      padding: "14px 20px",
      border: "1px solid #eee",
      backgroundColor: "#fcfcfc",
      fontSize: "0.95rem"
    }
  };

useEffect(() => {
  if (!showModal) {
    const timer = setTimeout(() => {
      setFormData({
        name: "",
        mobile_number: "",
        customerNotes: "",
        email: "",
        adults: "1",
        children: "0",
        tentativeDate: "",
        type: "custom"
      });
      setSuccess("");
      setError("");
    }, 300);

    return () => clearTimeout(timer);
  }
}, [showModal]);
useEffect(() => {
  const fetchAdvertisements = async () => {
    try {
      const res = await axios.get(`${BASE_URL}api/web-advertisement`);
      if (res.data && res.data.length > 0) {
        setAdsData(res.data);      // store all ads
        setShowAdsModal(true);     // show popup immediately
      }
    } catch (err) {
      console.error("Advertisement fetch error:", err);
    }
  };

   const fetchPackages = async () => {
        try {
          const response = await axios.get(`${BASE_URL}api/web-all-tours`); // Replace with your API endpoint
          setPackages(response?.data?.allTours);
          setHotPackages(response?.data?.trading)
        } catch (error) {
          console.error("Error fetching packages:", error);
        }
      };
  
         const fetchPackagesApi = async () => {
        try {
          const response = await axios.get(`${BASE_URL}api/web-dashboard`); // Replace with your API endpoint
          setHomeImages(response?.data);
        } catch (error) {
          console.error("Error fetching packages:", error);
        }
      };

  fetchAdvertisements();
  
    fetchPackages();
    fetchPackagesApi();
}, []);
const navigate = useNavigate();

const handleAdClick = (ad) => {
  if (ad.type === "sector") {
    navigate(`/allpackeges/${ad.selectedpackageandsector}`);
  } else {
    // Default or other types
    const cleanId = ad.selectedpackageandsector.replace("tour-", "");
    navigate(`/tour-details/${cleanId}`);
  }
  setShowAdsModal(false);
};
  return (
    <div className="App">
      <ScrollToTopOnRouteChange />
      <div style={mainContentStyle}>

        <div style={headerStyle}>
          <Header isScrolled={isScrolled} menus={menus} tourSector={tourSector} />
        </div>

        {!hideQuickInquiry && (
          <div style={{
            position: "fixed",
            right: "0px",
            bottom: "50vh",
            zIndex: 99999,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "15px"
          }}>

            <div
              onClick={() => setShowModal(true)}
              style={{
                backgroundColor: "#ff5722", 
                color: "#ffffff",
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "24px",
                cursor: "pointer",
                boxShadow: "0 10px 25px rgba(255, 87, 34, 0.4)",
                border: "none",
                position: "relative"
              }}
            >
<FaEdit />

              <span style={{
                position: "absolute",
                top: "0px",
                right: "0px",
                backgroundColor: "#082e5e",
                width: "20px",
                height: "20px",
                borderRadius: "50%",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "2px solid #fff"
              }}>
                +
              </span>
            </div>
          </div>
        )}

         {!hideQuickInquiry && (
          <div style={{
            position: "fixed",
            right: "10px",
            bottom: "20px",
            zIndex: 99999,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "15px"
          }}>

            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {webSettings?.socialMedia?.map((item, index) => (
                <div
                  key={index}
                  onClick={() => window.open(item.link, "_blank")}
                  style={{
                    cursor: "pointer",
                    width: "42px",
                    height: "42px",
                    backgroundColor: "#ffffff",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                    border: "1px solid #eee"
                  }}
                >
                  <img
                    src={`${item.iconLink}`}
                    alt={item.type}
                    style={{ width: "20px", height: "20px", objectFit: "contain" }}
                   
                  />
                </div>
              ))}
            </div>

        
          </div>
        )}
        <div>
          <Routes>
            <Route path="/" element={<Home webTours={webTours} packages={packages} hotPackages={hotPackages} homeImages={homeImages} />} />
            <Route path="/allpackeges/:id" element={<AllPackeges webdata={webSettings}/>} />
            <Route path="/tour-details/:id" element={<PackegDetails />} />
            <Route path="/moments" element={<GalleryPage />} />
            <Route path="/blog" element={<BlogLandingPage />} />
            <Route path="/blog/:id" element={<BlogDetailsPage />} />
            <Route path="/contact-us" element={<ContactUsPage webSettings={webSettings} />} />
            <Route path="/about-us" element={<AboutUs webSettings={webSettings} />} />
          </Routes>
          <FooterSection
            footerData={webSettings}
            chardhamData={menus}
            tourSector={tourSector}
          />
     <Modal
  show={showModal && !hideQuickInquiry}
  onHide={() => setShowModal(false)}
  centered
  size="lg" // Increased size for professional spacing
  dialogClassName="custom-modal"
>
  <div style={{ 
    ...styles.infoCard, 
    borderTop: `8px solid ${theme.primary}`, 
    padding: "40px",
    borderRadius: "20px" 
  }}>
    {/* Header Section */}
    <div className="mb-4 d-flex justify-content-between align-items-center">
      <div>
        <h3 className="fw-bold mb-1" style={{ color: theme.dark, letterSpacing: "-0.5px" }}>
Quick Inquiry
        </h3>
        <p className="text-muted mb-0">Fill in the details below and our travel experts will contact you.</p>
      </div>
      <button 
        onClick={() => setShowModal(false)} 
        style={{ border: 'none', background: '#f8f9fa', borderRadius: '50%', width: '35px', height: '35px', color: '#666' }}
      >
        ✕
      </button>
    </div>

    <Form onSubmit={handleSubmit}>
      {success ? (
         <div className="text-center py-5 animate__animated animate__fadeIn">
    {/* Animated Success Icon */}
    <div className="mb-4">
      <div style={{ 
        width: "100px", 
        height: "100px", 
        background: "#f0fff4", 
        color: "#28a745", 
        borderRadius: "50%", 
        display: "inline-flex", 
        alignItems: "center", 
        justifyContent: "center", 
        fontSize: "3rem",
        boxShadow: "0 10px 20px rgba(40, 167, 69, 0.1)"
      }}>
        ✓
      </div>
    </div>

    {/* The Professional Message */}
    <h3 className="fw-bold" style={{ color: theme.dark, marginBottom: "15px" }}>
      Inquiry Submitted Successfully!
    </h3>
    
    <div className="px-md-4">
      <p style={{ color: "#555", lineHeight: "1.6", fontSize: "1.05rem" }}>
        Dear <strong>{formData.name || "Traveler"}</strong>, thank you for choosing 
        Radheshyam Group. We have received your inquiry.
      </p>
      
      <p className="text-muted small" style={{ backgroundColor: "#f8f9fa", padding: "15px", borderRadius: "12px", borderLeft: `4px solid ${theme.primary}` }}>
        One of our senior destination experts will review your requirements. 
        You will receive a personalized itinerary and a best-price quote on your 
        provided mobile number/email within the next 24 hours.
      </p>
    </div>

    {/* Branded Footer */}
    <div className="mt-4 pt-3 border-top">
      <p className="mb-1 fw-bold" style={{ color: theme.primary }}>Radheshyam Group</p>
      <span className="text-muted small">Quality Tours • Trusted Service • Best Price</span>
    </div>

 
  </div>
      ) : (
        <>
          {/* Row 1: Name & Mobile */}
          <div className="row mt-2">
            <div className="col-md-6 mb-3">
              <Form.Label className="small fw-bold text-secondary text-uppercase">Full Name</Form.Label>
              <Form.Control
                style={styles.input}
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="e.g. Rahul Sharma"
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <Form.Label className="small fw-bold text-secondary text-uppercase">Mobile Number</Form.Label>
              <Form.Control
                style={styles.input}
                type="tel"
                name="mobile_number"
                value={formData.mobile_number}
                onChange={handleChange}
                placeholder="+91 00000 00000"
                required
              />
            </div>
          </div>

          {/* Row 2: Email */}
          <Form.Group className="mb-3">
            <Form.Label className="small fw-bold text-secondary text-uppercase">Email Address</Form.Label>
            <Form.Control
              style={styles.input}
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="name@example.com"
            />
          </Form.Group>

          {/* Row 3: Travel Details (The 3 New Fields) */}
          <div className="row p-3 mb-3" style={{ background: "#f8f9fa", borderRadius: "15px", border: "1px solid #eee" }}>
            <div className="col-md-4 mb-2">
              <Form.Label className="small fw-bold text-dark">Adults</Form.Label>
              <Form.Control
                style={{...styles.input, border: "1px solid #ddd"}}
                type="number"
                min="1"
                name="adults"
                value={formData.adults}
                onChange={handleChange}
                placeholder="1"
                required
              />
            </div>
            <div className="col-md-4 mb-2">
              <Form.Label className="small fw-bold text-dark">Children</Form.Label>
              <Form.Control
                style={{...styles.input, border: "1px solid #ddd"}}
                type="number"
                min="0"
                name="children"
                value={formData.children}
                onChange={handleChange}
                placeholder="0"
              />
            </div>
            <div className="col-md-4 mb-2">
              <Form.Label className="small fw-bold text-dark">Travel Date</Form.Label>
              <Form.Control
                style={{...styles.input, border: "1px solid #ddd"}}
                type="date"
                min={today}
                name="tentativeDate"
                value={formData.tentativeDate}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* Row 4: Message */}
          <Form.Group className="mb-4">
            <Form.Label className="small fw-bold text-secondary text-uppercase">Special Notes / Requirements</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              style={styles.input}
              name="customerNotes"
              value={formData.customerNotes}
              onChange={handleChange}
              placeholder="Tell us about the destinations you're interested in..."
              required
            />
          </Form.Group>

          {/* Submit Button */}
          <Button
            type="submit"
            className="w-100 py-3 border-0 shadow"
            style={{ 
              borderRadius: "12px", 
              fontWeight: "700", 
              backgroundColor: theme.dark,
              fontSize: "1.1rem",
              transition: "all 0.3s ease"
            }}
            disabled={loading}
          >
            {loading ? (
              <span className="spinner-border spinner-border-sm me-2"></span>
            ) : null}
            {loading ? "PROCESSING..." : "SEND MESSAGE"}
          </Button>
        </>
      )}
      {error && <p className="text-danger small mt-3 text-center fw-bold">{error}</p>}
    </Form>
  </div>
</Modal>
<Modal
  show={showAdsModal}
  onHide={() => setShowAdsModal(false)}
  centered
  size="lg"
  className="modern-ads-modal"
>
  <Modal.Body className="p-0 position-relative">
    <button className="custom-close-btn" onClick={() => setShowAdsModal(false)}>×</button>
    
    {adsData.length > 0 && (
      <Carousel interval={5000} fade indicators={adsData.length > 1} controls={adsData.length > 1}>
        {adsData.map((ad, index) => (
          <Carousel.Item key={index} onClick={() => handleAdClick(ad)} style={{ cursor: 'pointer' }}>
            <div className="ad-image-container">
              {ad.image && (
             <img
  className="d-block w-100"
                  src={`${BASE_URL}${ad.image}`|| `${BASE_URL}${ad.image}`}
                  alt="Advertisement"
                 
/>
              )}
              <div className="ad-overlay">
                <div className="ad-content">
                  <span className="ad-badge">Special Offer</span>
                  <h3 className="ad-title">{ad.description}</h3>
                  <button className="btn-modern-action">Explore Now</button>
                </div>
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    )}
  </Modal.Body>
</Modal>

        </div>
      </div>
    </div>
  );
}


function App() {
  return (
    <Router basename="/">
      <AppContent />
    </Router>
  );
}

export default App;
